/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Whether 9am is waiting for the member's pharmacy medication history from the health information exchange.
 */
export type MedicationHistorySyncStatusResponse = {
    /**
     * NOT_REQUESTED if the medication history was never requested for the member, PENDING while the most recent request is open, COMPLETED once it was delivered, with or without medication data.
     */
    status: MedicationHistorySyncStatusResponse.status;
    /**
     * The date the most recent request was sent, if any.
     */
    requestedAt?: string;
    /**
     * The date the most recent request was completed, if already delivered.
     */
    completedAt?: string;
};

export namespace MedicationHistorySyncStatusResponse {

    /**
     * NOT_REQUESTED if the medication history was never requested for the member, PENDING while the most recent request is open, COMPLETED once it was delivered, with or without medication data.
     */
    export enum status {
        NOT_REQUESTED = 'NOT_REQUESTED',
        PENDING = 'PENDING',
        COMPLETED = 'COMPLETED',
    }


}

